/* Interface for App Languages */
import { z } from 'zod';

const IAppDetailsLanguageFileSchema = z.object({
  "$schema": z.string(),
  "name.short": z.string(),
  "name.full": z.string(),
  "description.full": z.string(),
  "description.short": z.string(),
  "localizationKeys": z.record(z.string(), z.any()).nullish()
})

export const IAppDetailsLanguageSchema = z.object({
  languageTag: z.string(),
  languageDetail: z.object({
    nativeName: z.string(),
    nativeLanguageCode: z.string(),
    languageName: z.string(),
    regionCode: z.string(),
    languageCode: z.string(),
    regionName: z.string()
  }).nullish(),
  file: IAppDetailsLanguageFileSchema.nullish()
});

export const ILocalizationInfoSchema = z.object({
  defaultLanguageTag: z.string().nullable().optional(),
  defaultLanguageFile: z.string().nullable().optional(),
  backgroundLoadConfiguration: z.string().nullable().optional(),
  languages: z.array(IAppDetailsLanguageSchema).nullable().optional(),
});

export type IAppDetailsLanguage = z.infer<typeof IAppDetailsLanguageSchema>;

export type IAppDetailsLanguageFile = z.infer<typeof IAppDetailsLanguageFileSchema>;
